import { render, staticRenderFns } from "./plug-ad-list.vue?vue&type=template&id=7a637086&scoped=true&"
import script from "./plug-ad-list.vue?vue&type=script&lang=js&"
export * from "./plug-ad-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a637086",
  null
  
)

export default component.exports